
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kVx8h", function(module, exports) {

$parcel$export(module.exports, "register", () => $f3c2d4f5f568aeaa$export$6503ec6e8aabbaf, (v) => $f3c2d4f5f568aeaa$export$6503ec6e8aabbaf = v);
var $f3c2d4f5f568aeaa$export$6503ec6e8aabbaf;
var $f3c2d4f5f568aeaa$export$f7ad0328861e2f03;
"use strict";
var $f3c2d4f5f568aeaa$var$mapping = new Map();
function $f3c2d4f5f568aeaa$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f3c2d4f5f568aeaa$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f3c2d4f5f568aeaa$var$resolve(id) {
    var resolved = $f3c2d4f5f568aeaa$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f3c2d4f5f568aeaa$export$6503ec6e8aabbaf = $f3c2d4f5f568aeaa$var$register;
$f3c2d4f5f568aeaa$export$f7ad0328861e2f03 = $f3c2d4f5f568aeaa$var$resolve;

});

var $205dbd88693108c6$exports = {};

(parcelRequire("kVx8h")).register(new URL("", import.meta.url).toString(), JSON.parse('["7bzDS","05.bc1c6d8f.js","80C4Q","../RobotoMono-Medium.5a7b3c17.ttf","l3eUY","01.660f2584.js","99yyr","01.bff02f15.js"]'));


var $lyoVb = parcelRequire("lyoVb");
var $90ed7a381e6de542$exports = {};
(function(f) {
    var g;
    $90ed7a381e6de542$exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(require1, module1, exports) {
                var process = module1.exports = {};
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error("setTimeout has not been defined");
                }
                function defaultClearTimeout() {
                    throw new Error("clearTimeout has not been defined");
                }
                (function() {
                    try {
                        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) return setTimeout(fun, 0);
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) return clearTimeout(marker);
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = "browser";
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = "";
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error("process.binding is not supported");
                };
                process.cwd = function() {
                    return "/";
                };
                process.chdir = function(dir) {
                    throw new Error("process.chdir is not supported");
                };
                process.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        2: [
            function(require1, module1, exports) {
                (function(process) {
                    (function() {
                        !function(t, e) {
                            "object" == typeof exports && "undefined" != typeof module1 ? module1.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).polygonClipping = e();
                        }(this, function() {
                            "use strict";
                            function t(t, e) {
                                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                            }
                            function e(t, e) {
                                for(var r = 0; r < e.length; r++){
                                    var n = e[r];
                                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                                }
                            }
                            function r(t, r, n) {
                                return r && e(t.prototype, r), n && e(t, n), t;
                            }
                            var n = function(t, e) {
                                this.next = null, this.key = t, this.data = e, this.left = null, this.right = null;
                            };
                            function i(t, e) {
                                return t > e ? 1 : t < e ? -1 : 0;
                            }
                            function o(t, e, r) {
                                for(var i = new n(null, null), o = i, s = i;;){
                                    var u = r(t, e.key);
                                    if (u < 0) {
                                        if (null === e.left) break;
                                        if (r(t, e.left.key) < 0) {
                                            var l = e.left;
                                            if (e.left = l.right, l.right = e, null === (e = l).left) break;
                                        }
                                        s.left = e, s = e, e = e.left;
                                    } else {
                                        if (!(u > 0)) break;
                                        if (null === e.right) break;
                                        if (r(t, e.right.key) > 0) {
                                            l = e.right;
                                            if (e.right = l.left, l.left = e, null === (e = l).right) break;
                                        }
                                        o.right = e, o = e, e = e.right;
                                    }
                                }
                                return o.right = e.left, s.left = e.right, e.left = i.right, e.right = i.left, e;
                            }
                            function s(t, e, r, i) {
                                var s = new n(t, e);
                                if (null === r) return s.left = s.right = null, s;
                                var u = i(t, (r = o(t, r, i)).key);
                                return u < 0 ? (s.left = r.left, s.right = r, r.left = null) : u >= 0 && (s.right = r.right, s.left = r, r.right = null), s;
                            }
                            function u(t, e, r) {
                                var n = null, i = null;
                                if (e) {
                                    var s = r((e = o(t, e, r)).key, t);
                                    0 === s ? (n = e.left, i = e.right) : s < 0 ? (i = e.right, e.right = null, n = e) : (n = e.left, e.left = null, i = e);
                                }
                                return {
                                    left: n,
                                    right: i
                                };
                            }
                            function l(t, e, r, n, i) {
                                if (t) {
                                    n(e + (r ? "\u2514\u2500\u2500 " : "\u251C\u2500\u2500 ") + i(t) + "\n");
                                    var o = e + (r ? "    " : "\u2502   ");
                                    t.left && l(t.left, o, !1, n, i), t.right && l(t.right, o, !0, n, i);
                                }
                            }
                            var h = function() {
                                function t(t) {
                                    void 0 === t && (t = i), this._root = null, this._size = 0, this._comparator = t;
                                }
                                return t.prototype.insert = function(t, e) {
                                    return this._size++, this._root = s(t, e, this._root, this._comparator);
                                }, t.prototype.add = function(t, e) {
                                    var r = new n(t, e);
                                    null === this._root && (r.left = r.right = null, this._size++, this._root = r);
                                    var i = this._comparator, s = o(t, this._root, i), u = i(t, s.key);
                                    return 0 === u ? this._root = s : (u < 0 ? (r.left = s.left, r.right = s, s.left = null) : u > 0 && (r.right = s.right, r.left = s, s.right = null), this._size++, this._root = r), this._root;
                                }, t.prototype.remove = function(t) {
                                    this._root = this._remove(t, this._root, this._comparator);
                                }, t.prototype._remove = function(t, e, r) {
                                    var n;
                                    return null === e ? null : 0 === r(t, (e = o(t, e, r)).key) ? (null === e.left ? n = e.right : (n = o(t, e.left, r)).right = e.right, this._size--, n) : e;
                                }, t.prototype.pop = function() {
                                    var t = this._root;
                                    if (t) {
                                        for(; t.left;)t = t.left;
                                        return this._root = o(t.key, this._root, this._comparator), this._root = this._remove(t.key, this._root, this._comparator), {
                                            key: t.key,
                                            data: t.data
                                        };
                                    }
                                    return null;
                                }, t.prototype.findStatic = function(t) {
                                    for(var e = this._root, r = this._comparator; e;){
                                        var n = r(t, e.key);
                                        if (0 === n) return e;
                                        e = n < 0 ? e.left : e.right;
                                    }
                                    return null;
                                }, t.prototype.find = function(t) {
                                    return this._root && (this._root = o(t, this._root, this._comparator), 0 !== this._comparator(t, this._root.key)) ? null : this._root;
                                }, t.prototype.contains = function(t) {
                                    for(var e = this._root, r = this._comparator; e;){
                                        var n = r(t, e.key);
                                        if (0 === n) return !0;
                                        e = n < 0 ? e.left : e.right;
                                    }
                                    return !1;
                                }, t.prototype.forEach = function(t, e) {
                                    for(var r = this._root, n = [], i = !1; !i;)null !== r ? (n.push(r), r = r.left) : 0 !== n.length ? (r = n.pop(), t.call(e, r), r = r.right) : i = !0;
                                    return this;
                                }, t.prototype.range = function(t, e, r, n) {
                                    for(var i = [], o = this._comparator, s = this._root; 0 !== i.length || s;)if (s) i.push(s), s = s.left;
                                    else {
                                        if (o((s = i.pop()).key, e) > 0) break;
                                        if (o(s.key, t) >= 0 && r.call(n, s)) return this;
                                        s = s.right;
                                    }
                                    return this;
                                }, t.prototype.keys = function() {
                                    var t = [];
                                    return this.forEach(function(e) {
                                        var r = e.key;
                                        return t.push(r);
                                    }), t;
                                }, t.prototype.values = function() {
                                    var t = [];
                                    return this.forEach(function(e) {
                                        var r = e.data;
                                        return t.push(r);
                                    }), t;
                                }, t.prototype.min = function() {
                                    return this._root ? this.minNode(this._root).key : null;
                                }, t.prototype.max = function() {
                                    return this._root ? this.maxNode(this._root).key : null;
                                }, t.prototype.minNode = function(t) {
                                    if (void 0 === t && (t = this._root), t) for(; t.left;)t = t.left;
                                    return t;
                                }, t.prototype.maxNode = function(t) {
                                    if (void 0 === t && (t = this._root), t) for(; t.right;)t = t.right;
                                    return t;
                                }, t.prototype.at = function(t) {
                                    for(var e = this._root, r = !1, n = 0, i = []; !r;)if (e) i.push(e), e = e.left;
                                    else if (i.length > 0) {
                                        if (e = i.pop(), n === t) return e;
                                        n++, e = e.right;
                                    } else r = !0;
                                    return null;
                                }, t.prototype.next = function(t) {
                                    var e = this._root, r = null;
                                    if (t.right) {
                                        for(r = t.right; r.left;)r = r.left;
                                        return r;
                                    }
                                    for(var n = this._comparator; e;){
                                        var i = n(t.key, e.key);
                                        if (0 === i) break;
                                        i < 0 ? (r = e, e = e.left) : e = e.right;
                                    }
                                    return r;
                                }, t.prototype.prev = function(t) {
                                    var e = this._root, r = null;
                                    if (null !== t.left) {
                                        for(r = t.left; r.right;)r = r.right;
                                        return r;
                                    }
                                    for(var n = this._comparator; e;){
                                        var i = n(t.key, e.key);
                                        if (0 === i) break;
                                        i < 0 ? e = e.left : (r = e, e = e.right);
                                    }
                                    return r;
                                }, t.prototype.clear = function() {
                                    return this._root = null, this._size = 0, this;
                                }, t.prototype.toList = function() {
                                    return function(t) {
                                        var e = t, r = [], i = !1, o = new n(null, null), s = o;
                                        for(; !i;)e ? (r.push(e), e = e.left) : r.length > 0 ? e = (e = s = s.next = r.pop()).right : i = !0;
                                        return s.next = null, o.next;
                                    }(this._root);
                                }, t.prototype.load = function(t, e, r) {
                                    void 0 === e && (e = []), void 0 === r && (r = !1);
                                    var i = t.length, o = this._comparator;
                                    if (r && p(t, e, 0, i - 1, o), null === this._root) this._root = f(t, e, 0, i), this._size = i;
                                    else {
                                        var s = function(t, e, r) {
                                            var i = new n(null, null), o = i, s = t, u = e;
                                            for(; null !== s && null !== u;)r(s.key, u.key) < 0 ? (o.next = s, s = s.next) : (o.next = u, u = u.next), o = o.next;
                                            null !== s ? o.next = s : null !== u && (o.next = u);
                                            return i.next;
                                        }(this.toList(), function(t, e) {
                                            for(var r = new n(null, null), i = r, o = 0; o < t.length; o++)i = i.next = new n(t[o], e[o]);
                                            return i.next = null, r.next;
                                        }(t, e), o);
                                        i = this._size + i, this._root = a({
                                            head: s
                                        }, 0, i);
                                    }
                                    return this;
                                }, t.prototype.isEmpty = function() {
                                    return null === this._root;
                                }, Object.defineProperty(t.prototype, "size", {
                                    get: function() {
                                        return this._size;
                                    },
                                    enumerable: !0,
                                    configurable: !0
                                }), Object.defineProperty(t.prototype, "root", {
                                    get: function() {
                                        return this._root;
                                    },
                                    enumerable: !0,
                                    configurable: !0
                                }), t.prototype.toString = function(t) {
                                    void 0 === t && (t = function(t) {
                                        return String(t.key);
                                    });
                                    var e = [];
                                    return l(this._root, "", !0, function(t) {
                                        return e.push(t);
                                    }, t), e.join("");
                                }, t.prototype.update = function(t, e, r) {
                                    var n = this._comparator, i = u(t, this._root, n), l = i.left, h = i.right;
                                    n(t, e) < 0 ? h = s(e, r, h, n) : l = s(e, r, l, n), this._root = function(t, e, r) {
                                        return null === e ? t : (null === t || ((e = o(t.key, e, r)).left = t), e);
                                    }(l, h, n);
                                }, t.prototype.split = function(t) {
                                    return u(t, this._root, this._comparator);
                                }, t;
                            }();
                            function f(t, e, r, i) {
                                var o = i - r;
                                if (o > 0) {
                                    var s = r + Math.floor(o / 2), u = t[s], l = e[s], h = new n(u, l);
                                    return h.left = f(t, e, r, s), h.right = f(t, e, s + 1, i), h;
                                }
                                return null;
                            }
                            function a(t, e, r) {
                                var n = r - e;
                                if (n > 0) {
                                    var i = e + Math.floor(n / 2), o = a(t, e, i), s = t.head;
                                    return s.left = o, t.head = t.head.next, s.right = a(t, i + 1, r), s;
                                }
                                return null;
                            }
                            function p(t, e, r, n, i) {
                                if (!(r >= n)) {
                                    for(var o = t[r + n >> 1], s = r - 1, u = n + 1;;){
                                        do s++;
                                        while (i(t[s], o) < 0);
                                        do u--;
                                        while (i(t[u], o) > 0);
                                        if (s >= u) break;
                                        var l = t[s];
                                        t[s] = t[u], t[u] = l, l = e[s], e[s] = e[u], e[u] = l;
                                    }
                                    p(t, e, r, u, i), p(t, e, u + 1, n, i);
                                }
                            }
                            var y = function(t, e) {
                                return t.ll.x <= e.x && e.x <= t.ur.x && t.ll.y <= e.y && e.y <= t.ur.y;
                            }, g = function(t, e) {
                                if (e.ur.x < t.ll.x || t.ur.x < e.ll.x || e.ur.y < t.ll.y || t.ur.y < e.ll.y) return null;
                                var r = t.ll.x < e.ll.x ? e.ll.x : t.ll.x, n = t.ur.x < e.ur.x ? t.ur.x : e.ur.x;
                                return {
                                    ll: {
                                        x: r,
                                        y: t.ll.y < e.ll.y ? e.ll.y : t.ll.y
                                    },
                                    ur: {
                                        x: n,
                                        y: t.ur.y < e.ur.y ? t.ur.y : e.ur.y
                                    }
                                };
                            }, v = Number.EPSILON;
                            void 0 === v && (v = Math.pow(2, -52));
                            var c = v * v, x = function(t, e) {
                                if (-v < t && t < v && -v < e && e < v) return 0;
                                var r = t - e;
                                return r * r < c * t * e ? 0 : t < e ? -1 : 1;
                            }, b = function() {
                                function e() {
                                    t(this, e), this.reset();
                                }
                                return r(e, [
                                    {
                                        key: "reset",
                                        value: function() {
                                            this.xRounder = new m, this.yRounder = new m;
                                        }
                                    },
                                    {
                                        key: "round",
                                        value: function(t, e) {
                                            return {
                                                x: this.xRounder.round(t),
                                                y: this.yRounder.round(e)
                                            };
                                        }
                                    }
                                ]), e;
                            }(), m = function() {
                                function e() {
                                    t(this, e), this.tree = new h, this.round(0);
                                }
                                return r(e, [
                                    {
                                        key: "round",
                                        value: function(t) {
                                            var e = this.tree.add(t), r = this.tree.prev(e);
                                            if (null !== r && 0 === x(e.key, r.key)) return this.tree.remove(t), r.key;
                                            var n = this.tree.next(e);
                                            return null !== n && 0 === x(e.key, n.key) ? (this.tree.remove(t), n.key) : t;
                                        }
                                    }
                                ]), e;
                            }(), d = new b, E = function(t, e) {
                                return t.x * e.y - t.y * e.x;
                            }, S = function(t, e) {
                                return t.x * e.x + t.y * e.y;
                            }, _ = function(t, e, r) {
                                var n = {
                                    x: e.x - t.x,
                                    y: e.y - t.y
                                }, i = {
                                    x: r.x - t.x,
                                    y: r.y - t.y
                                }, o = E(n, i);
                                return x(o, 0);
                            }, k = function(t) {
                                return Math.sqrt(S(t, t));
                            }, w = function(t, e, r) {
                                var n = {
                                    x: e.x - t.x,
                                    y: e.y - t.y
                                }, i = {
                                    x: r.x - t.x,
                                    y: r.y - t.y
                                };
                                return S(i, n) / k(i) / k(n);
                            }, R = function(t, e, r) {
                                return 0 === e.y ? null : {
                                    x: t.x + e.x / e.y * (r - t.y),
                                    y: r
                                };
                            }, I = function(t, e, r) {
                                return 0 === e.x ? null : {
                                    x: r,
                                    y: t.y + e.y / e.x * (r - t.x)
                                };
                            }, P = function() {
                                function e(r, n) {
                                    t(this, e), void 0 === r.events ? r.events = [
                                        this
                                    ] : r.events.push(this), this.point = r, this.isLeft = n;
                                }
                                return r(e, null, [
                                    {
                                        key: "compare",
                                        value: function(t, r) {
                                            var n = e.comparePoints(t.point, r.point);
                                            return 0 !== n ? n : (t.point !== r.point && t.link(r), t.isLeft !== r.isLeft ? t.isLeft ? 1 : -1 : O.compare(t.segment, r.segment));
                                        }
                                    },
                                    {
                                        key: "comparePoints",
                                        value: function(t, e) {
                                            return t.x < e.x ? -1 : t.x > e.x ? 1 : t.y < e.y ? -1 : t.y > e.y ? 1 : 0;
                                        }
                                    }
                                ]), r(e, [
                                    {
                                        key: "link",
                                        value: function(t) {
                                            if (t.point === this.point) throw new Error("Tried to link already linked events");
                                            for(var e = t.point.events, r = 0, n = e.length; r < n; r++){
                                                var i = e[r];
                                                this.point.events.push(i), i.point = this.point;
                                            }
                                            this.checkForConsuming();
                                        }
                                    },
                                    {
                                        key: "checkForConsuming",
                                        value: function() {
                                            for(var t = this.point.events.length, e = 0; e < t; e++){
                                                var r = this.point.events[e];
                                                if (void 0 === r.segment.consumedBy) for(var n = e + 1; n < t; n++){
                                                    var i = this.point.events[n];
                                                    void 0 === i.consumedBy && r.otherSE.point.events === i.otherSE.point.events && r.segment.consume(i.segment);
                                                }
                                            }
                                        }
                                    },
                                    {
                                        key: "getAvailableLinkedEvents",
                                        value: function() {
                                            for(var t = [], e = 0, r = this.point.events.length; e < r; e++){
                                                var n = this.point.events[e];
                                                n !== this && !n.segment.ringOut && n.segment.isInResult() && t.push(n);
                                            }
                                            return t;
                                        }
                                    },
                                    {
                                        key: "getLeftmostComparator",
                                        value: function(t) {
                                            var e = this, r = new Map, n = function(n) {
                                                var i, o, s, u, l, h = n.otherSE;
                                                r.set(n, {
                                                    sine: (i = e.point, o = t.point, s = h.point, u = {
                                                        x: o.x - i.x,
                                                        y: o.y - i.y
                                                    }, l = {
                                                        x: s.x - i.x,
                                                        y: s.y - i.y
                                                    }, E(l, u) / k(l) / k(u)),
                                                    cosine: w(e.point, t.point, h.point)
                                                });
                                            };
                                            return function(t, e) {
                                                r.has(t) || n(t), r.has(e) || n(e);
                                                var i = r.get(t), o = i.sine, s = i.cosine, u = r.get(e), l = u.sine, h = u.cosine;
                                                return o >= 0 && l >= 0 ? s < h ? 1 : s > h ? -1 : 0 : o < 0 && l < 0 ? s < h ? -1 : s > h ? 1 : 0 : l < o ? -1 : l > o ? 1 : 0;
                                            };
                                        }
                                    }
                                ]), e;
                            }(), N = 0, O = function() {
                                function e(r, n, i, o) {
                                    t(this, e), this.id = ++N, this.leftSE = r, r.segment = this, r.otherSE = n, this.rightSE = n, n.segment = this, n.otherSE = r, this.rings = i, this.windings = o;
                                }
                                return r(e, null, [
                                    {
                                        key: "compare",
                                        value: function(t, e) {
                                            var r = t.leftSE.point.x, n = e.leftSE.point.x, i = t.rightSE.point.x, o = e.rightSE.point.x;
                                            if (o < r) return 1;
                                            if (i < n) return -1;
                                            var s = t.leftSE.point.y, u = e.leftSE.point.y, l = t.rightSE.point.y, h = e.rightSE.point.y;
                                            if (r < n) {
                                                if (u < s && u < l) return 1;
                                                if (u > s && u > l) return -1;
                                                var f = t.comparePoint(e.leftSE.point);
                                                if (f < 0) return 1;
                                                if (f > 0) return -1;
                                                var a = e.comparePoint(t.rightSE.point);
                                                return 0 !== a ? a : -1;
                                            }
                                            if (r > n) {
                                                if (s < u && s < h) return -1;
                                                if (s > u && s > h) return 1;
                                                var p = e.comparePoint(t.leftSE.point);
                                                if (0 !== p) return p;
                                                var y = t.comparePoint(e.rightSE.point);
                                                return y < 0 ? 1 : y > 0 ? -1 : 1;
                                            }
                                            if (s < u) return -1;
                                            if (s > u) return 1;
                                            if (i < o) {
                                                var g = e.comparePoint(t.rightSE.point);
                                                if (0 !== g) return g;
                                            }
                                            if (i > o) {
                                                var v = t.comparePoint(e.rightSE.point);
                                                if (v < 0) return 1;
                                                if (v > 0) return -1;
                                            }
                                            if (i !== o) {
                                                var c = l - s, x = i - r, b = h - u, m = o - n;
                                                if (c > x && b < m) return 1;
                                                if (c < x && b > m) return -1;
                                            }
                                            return i > o ? 1 : i < o || l < h ? -1 : l > h ? 1 : t.id < e.id ? -1 : t.id > e.id ? 1 : 0;
                                        }
                                    }
                                ]), r(e, [
                                    {
                                        key: "replaceRightSE",
                                        value: function(t) {
                                            this.rightSE = t, this.rightSE.segment = this, this.rightSE.otherSE = this.leftSE, this.leftSE.otherSE = this.rightSE;
                                        }
                                    },
                                    {
                                        key: "bbox",
                                        value: function() {
                                            var t = this.leftSE.point.y, e = this.rightSE.point.y;
                                            return {
                                                ll: {
                                                    x: this.leftSE.point.x,
                                                    y: t < e ? t : e
                                                },
                                                ur: {
                                                    x: this.rightSE.point.x,
                                                    y: t > e ? t : e
                                                }
                                            };
                                        }
                                    },
                                    {
                                        key: "vector",
                                        value: function() {
                                            return {
                                                x: this.rightSE.point.x - this.leftSE.point.x,
                                                y: this.rightSE.point.y - this.leftSE.point.y
                                            };
                                        }
                                    },
                                    {
                                        key: "isAnEndpoint",
                                        value: function(t) {
                                            return t.x === this.leftSE.point.x && t.y === this.leftSE.point.y || t.x === this.rightSE.point.x && t.y === this.rightSE.point.y;
                                        }
                                    },
                                    {
                                        key: "comparePoint",
                                        value: function(t) {
                                            if (this.isAnEndpoint(t)) return 0;
                                            var e = this.leftSE.point, r = this.rightSE.point, n = this.vector();
                                            if (e.x === r.x) return t.x === e.x ? 0 : t.x < e.x ? 1 : -1;
                                            var i = (t.y - e.y) / n.y, o = e.x + i * n.x;
                                            if (t.x === o) return 0;
                                            var s = (t.x - e.x) / n.x, u = e.y + s * n.y;
                                            return t.y === u ? 0 : t.y < u ? -1 : 1;
                                        }
                                    },
                                    {
                                        key: "getIntersection",
                                        value: function(t) {
                                            var e = this.bbox(), r = t.bbox(), n = g(e, r);
                                            if (null === n) return null;
                                            var i = this.leftSE.point, o = this.rightSE.point, s = t.leftSE.point, u = t.rightSE.point, l = y(e, s) && 0 === this.comparePoint(s), h = y(r, i) && 0 === t.comparePoint(i), f = y(e, u) && 0 === this.comparePoint(u), a = y(r, o) && 0 === t.comparePoint(o);
                                            if (h && l) return a && !f ? o : !a && f ? u : null;
                                            if (h) return f && i.x === u.x && i.y === u.y ? null : i;
                                            if (l) return a && o.x === s.x && o.y === s.y ? null : s;
                                            if (a && f) return null;
                                            if (a) return o;
                                            if (f) return u;
                                            var p = function(t, e, r, n) {
                                                if (0 === e.x) return I(r, n, t.x);
                                                if (0 === n.x) return I(t, e, r.x);
                                                if (0 === e.y) return R(r, n, t.y);
                                                if (0 === n.y) return R(t, e, r.y);
                                                var i = E(e, n);
                                                if (0 == i) return null;
                                                var o = {
                                                    x: r.x - t.x,
                                                    y: r.y - t.y
                                                }, s = E(o, e) / i, u = E(o, n) / i;
                                                return {
                                                    x: (t.x + u * e.x + (r.x + s * n.x)) / 2,
                                                    y: (t.y + u * e.y + (r.y + s * n.y)) / 2
                                                };
                                            }(i, this.vector(), s, t.vector());
                                            return null === p ? null : y(n, p) ? d.round(p.x, p.y) : null;
                                        }
                                    },
                                    {
                                        key: "split",
                                        value: function(t) {
                                            var r = [], n = void 0 !== t.events, i = new P(t, !0), o = new P(t, !1), s = this.rightSE;
                                            this.replaceRightSE(o), r.push(o), r.push(i);
                                            var u = new e(i, s, this.rings.slice(), this.windings.slice());
                                            return P.comparePoints(u.leftSE.point, u.rightSE.point) > 0 && u.swapEvents(), P.comparePoints(this.leftSE.point, this.rightSE.point) > 0 && this.swapEvents(), n && (i.checkForConsuming(), o.checkForConsuming()), r;
                                        }
                                    },
                                    {
                                        key: "swapEvents",
                                        value: function() {
                                            var t = this.rightSE;
                                            this.rightSE = this.leftSE, this.leftSE = t, this.leftSE.isLeft = !0, this.rightSE.isLeft = !1;
                                            for(var e = 0, r = this.windings.length; e < r; e++)this.windings[e] *= -1;
                                        }
                                    },
                                    {
                                        key: "consume",
                                        value: function(t) {
                                            for(var r = this, n = t; r.consumedBy;)r = r.consumedBy;
                                            for(; n.consumedBy;)n = n.consumedBy;
                                            var i = e.compare(r, n);
                                            if (0 !== i) {
                                                if (i > 0) {
                                                    var o = r;
                                                    r = n, n = o;
                                                }
                                                if (r.prev === n) {
                                                    var s = r;
                                                    r = n, n = s;
                                                }
                                                for(var u = 0, l = n.rings.length; u < l; u++){
                                                    var h = n.rings[u], f = n.windings[u], a = r.rings.indexOf(h);
                                                    -1 === a ? (r.rings.push(h), r.windings.push(f)) : r.windings[a] += f;
                                                }
                                                n.rings = null, n.windings = null, n.consumedBy = r, n.leftSE.consumedBy = r.leftSE, n.rightSE.consumedBy = r.rightSE;
                                            }
                                        }
                                    },
                                    {
                                        key: "prevInResult",
                                        value: function() {
                                            return void 0 !== this._prevInResult || (this.prev ? this.prev.isInResult() ? this._prevInResult = this.prev : this._prevInResult = this.prev.prevInResult() : this._prevInResult = null), this._prevInResult;
                                        }
                                    },
                                    {
                                        key: "beforeState",
                                        value: function() {
                                            if (void 0 !== this._beforeState) return this._beforeState;
                                            if (this.prev) {
                                                var t = this.prev.consumedBy || this.prev;
                                                this._beforeState = t.afterState();
                                            } else this._beforeState = {
                                                rings: [],
                                                windings: [],
                                                multiPolys: []
                                            };
                                            return this._beforeState;
                                        }
                                    },
                                    {
                                        key: "afterState",
                                        value: function() {
                                            if (void 0 !== this._afterState) return this._afterState;
                                            var t = this.beforeState();
                                            this._afterState = {
                                                rings: t.rings.slice(0),
                                                windings: t.windings.slice(0),
                                                multiPolys: []
                                            };
                                            for(var e = this._afterState.rings, r = this._afterState.windings, n = this._afterState.multiPolys, i = 0, o = this.rings.length; i < o; i++){
                                                var s = this.rings[i], u = this.windings[i], l = e.indexOf(s);
                                                -1 === l ? (e.push(s), r.push(u)) : r[l] += u;
                                            }
                                            for(var h = [], f = [], a = 0, p = e.length; a < p; a++)if (0 !== r[a]) {
                                                var y = e[a], g = y.poly;
                                                if (-1 === f.indexOf(g)) {
                                                    if (y.isExterior) h.push(g);
                                                    else {
                                                        -1 === f.indexOf(g) && f.push(g);
                                                        var v = h.indexOf(y.poly);
                                                        -1 !== v && h.splice(v, 1);
                                                    }
                                                }
                                            }
                                            for(var c = 0, x = h.length; c < x; c++){
                                                var b = h[c].multiPoly;
                                                -1 === n.indexOf(b) && n.push(b);
                                            }
                                            return this._afterState;
                                        }
                                    },
                                    {
                                        key: "isInResult",
                                        value: function() {
                                            if (this.consumedBy) return !1;
                                            if (void 0 !== this._isInResult) return this._isInResult;
                                            var t = this.beforeState().multiPolys, e = this.afterState().multiPolys;
                                            switch(F.type){
                                                case "union":
                                                    var r = 0 === t.length, n = 0 === e.length;
                                                    this._isInResult = r !== n;
                                                    break;
                                                case "intersection":
                                                    var i, o;
                                                    t.length < e.length ? (i = t.length, o = e.length) : (i = e.length, o = t.length), this._isInResult = o === F.numMultiPolys && i < o;
                                                    break;
                                                case "xor":
                                                    var s = Math.abs(t.length - e.length);
                                                    this._isInResult = s % 2 == 1;
                                                    break;
                                                case "difference":
                                                    var u = function(t) {
                                                        return 1 === t.length && t[0].isSubject;
                                                    };
                                                    this._isInResult = u(t) !== u(e);
                                                    break;
                                                default:
                                                    throw new Error("Unrecognized operation type found ".concat(F.type));
                                            }
                                            return this._isInResult;
                                        }
                                    }
                                ], [
                                    {
                                        key: "fromRing",
                                        value: function(t, r, n) {
                                            var i, o, s, u = P.comparePoints(t, r);
                                            if (u < 0) i = t, o = r, s = 1;
                                            else {
                                                if (!(u > 0)) throw new Error("Tried to create degenerate segment at [".concat(t.x, ", ").concat(t.y, "]"));
                                                i = r, o = t, s = -1;
                                            }
                                            return new e(new P(i, !0), new P(o, !1), [
                                                n
                                            ], [
                                                s
                                            ]);
                                        }
                                    }
                                ]), e;
                            }(), A = function() {
                                function e(r, n, i) {
                                    if (t(this, e), !Array.isArray(r) || 0 === r.length) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
                                    if (this.poly = n, this.isExterior = i, this.segments = [], "number" != typeof r[0][0] || "number" != typeof r[0][1]) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
                                    var o = d.round(r[0][0], r[0][1]);
                                    this.bbox = {
                                        ll: {
                                            x: o.x,
                                            y: o.y
                                        },
                                        ur: {
                                            x: o.x,
                                            y: o.y
                                        }
                                    };
                                    for(var s = o, u = 1, l = r.length; u < l; u++){
                                        if ("number" != typeof r[u][0] || "number" != typeof r[u][1]) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
                                        var h = d.round(r[u][0], r[u][1]);
                                        h.x === s.x && h.y === s.y || (this.segments.push(O.fromRing(s, h, this)), h.x < this.bbox.ll.x && (this.bbox.ll.x = h.x), h.y < this.bbox.ll.y && (this.bbox.ll.y = h.y), h.x > this.bbox.ur.x && (this.bbox.ur.x = h.x), h.y > this.bbox.ur.y && (this.bbox.ur.y = h.y), s = h);
                                    }
                                    o.x === s.x && o.y === s.y || this.segments.push(O.fromRing(s, o, this));
                                }
                                return r(e, [
                                    {
                                        key: "getSweepEvents",
                                        value: function() {
                                            for(var t = [], e = 0, r = this.segments.length; e < r; e++){
                                                var n = this.segments[e];
                                                t.push(n.leftSE), t.push(n.rightSE);
                                            }
                                            return t;
                                        }
                                    }
                                ]), e;
                            }(), L = function() {
                                function e(r, n) {
                                    if (t(this, e), !Array.isArray(r)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
                                    this.exteriorRing = new A(r[0], this, !0), this.bbox = {
                                        ll: {
                                            x: this.exteriorRing.bbox.ll.x,
                                            y: this.exteriorRing.bbox.ll.y
                                        },
                                        ur: {
                                            x: this.exteriorRing.bbox.ur.x,
                                            y: this.exteriorRing.bbox.ur.y
                                        }
                                    }, this.interiorRings = [];
                                    for(var i = 1, o = r.length; i < o; i++){
                                        var s = new A(r[i], this, !1);
                                        s.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = s.bbox.ll.x), s.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = s.bbox.ll.y), s.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = s.bbox.ur.x), s.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = s.bbox.ur.y), this.interiorRings.push(s);
                                    }
                                    this.multiPoly = n;
                                }
                                return r(e, [
                                    {
                                        key: "getSweepEvents",
                                        value: function() {
                                            for(var t = this.exteriorRing.getSweepEvents(), e = 0, r = this.interiorRings.length; e < r; e++)for(var n = this.interiorRings[e].getSweepEvents(), i = 0, o = n.length; i < o; i++)t.push(n[i]);
                                            return t;
                                        }
                                    }
                                ]), e;
                            }(), z = function() {
                                function e(r, n) {
                                    if (t(this, e), !Array.isArray(r)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
                                    try {
                                        "number" == typeof r[0][0][0] && (r = [
                                            r
                                        ]);
                                    } catch (t) {}
                                    this.polys = [], this.bbox = {
                                        ll: {
                                            x: Number.POSITIVE_INFINITY,
                                            y: Number.POSITIVE_INFINITY
                                        },
                                        ur: {
                                            x: Number.NEGATIVE_INFINITY,
                                            y: Number.NEGATIVE_INFINITY
                                        }
                                    };
                                    for(var i = 0, o = r.length; i < o; i++){
                                        var s = new L(r[i], this);
                                        s.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = s.bbox.ll.x), s.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = s.bbox.ll.y), s.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = s.bbox.ur.x), s.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = s.bbox.ur.y), this.polys.push(s);
                                    }
                                    this.isSubject = n;
                                }
                                return r(e, [
                                    {
                                        key: "getSweepEvents",
                                        value: function() {
                                            for(var t = [], e = 0, r = this.polys.length; e < r; e++)for(var n = this.polys[e].getSweepEvents(), i = 0, o = n.length; i < o; i++)t.push(n[i]);
                                            return t;
                                        }
                                    }
                                ]), e;
                            }(), B = function() {
                                function e(r) {
                                    t(this, e), this.events = r;
                                    for(var n = 0, i = r.length; n < i; n++)r[n].segment.ringOut = this;
                                    this.poly = null;
                                }
                                return r(e, null, [
                                    {
                                        key: "factory",
                                        value: function(t) {
                                            for(var r = [], n = 0, i = t.length; n < i; n++){
                                                var o = t[n];
                                                if (o.isInResult() && !o.ringOut) {
                                                    for(var s = null, u = o.leftSE, l = o.rightSE, h = [
                                                        u
                                                    ], f = u.point, a = []; s = u, u = l, h.push(u), u.point !== f;)for(;;){
                                                        var p = u.getAvailableLinkedEvents();
                                                        if (0 === p.length) {
                                                            var y = h[0].point, g = h[h.length - 1].point;
                                                            throw new Error("Unable to complete output ring starting at [".concat(y.x, ",") + " ".concat(y.y, "]. Last matching segment found ends at") + " [".concat(g.x, ", ").concat(g.y, "]."));
                                                        }
                                                        if (1 === p.length) {
                                                            l = p[0].otherSE;
                                                            break;
                                                        }
                                                        for(var v = null, c = 0, x = a.length; c < x; c++)if (a[c].point === u.point) {
                                                            v = c;
                                                            break;
                                                        }
                                                        if (null === v) {
                                                            a.push({
                                                                index: h.length,
                                                                point: u.point
                                                            });
                                                            var b = u.getLeftmostComparator(s);
                                                            l = p.sort(b)[0].otherSE;
                                                            break;
                                                        }
                                                        var m = a.splice(v)[0], d = h.splice(m.index);
                                                        d.unshift(d[0].otherSE), r.push(new e(d.reverse()));
                                                    }
                                                    r.push(new e(h));
                                                }
                                            }
                                            return r;
                                        }
                                    }
                                ]), r(e, [
                                    {
                                        key: "getGeom",
                                        value: function() {
                                            for(var t = this.events[0].point, e = [
                                                t
                                            ], r = 1, n = this.events.length - 1; r < n; r++){
                                                var i = this.events[r].point, o = this.events[r + 1].point;
                                                0 !== _(i, t, o) && (e.push(i), t = i);
                                            }
                                            if (1 === e.length) return null;
                                            var s = e[0], u = e[1];
                                            0 === _(s, t, u) && e.shift(), e.push(e[0]);
                                            for(var l = this.isExteriorRing() ? 1 : -1, h = this.isExteriorRing() ? 0 : e.length - 1, f = this.isExteriorRing() ? e.length : -1, a = [], p = h; p != f; p += l)a.push([
                                                e[p].x,
                                                e[p].y
                                            ]);
                                            return a;
                                        }
                                    },
                                    {
                                        key: "isExteriorRing",
                                        value: function() {
                                            if (void 0 === this._isExteriorRing) {
                                                var t = this.enclosingRing();
                                                this._isExteriorRing = !t || !t.isExteriorRing();
                                            }
                                            return this._isExteriorRing;
                                        }
                                    },
                                    {
                                        key: "enclosingRing",
                                        value: function() {
                                            return void 0 === this._enclosingRing && (this._enclosingRing = this._calcEnclosingRing()), this._enclosingRing;
                                        }
                                    },
                                    {
                                        key: "_calcEnclosingRing",
                                        value: function() {
                                            for(var t = this.events[0], e = 1, r = this.events.length; e < r; e++){
                                                var n = this.events[e];
                                                P.compare(t, n) > 0 && (t = n);
                                            }
                                            for(var i = t.segment.prevInResult(), o = i ? i.prevInResult() : null;;){
                                                if (!i) return null;
                                                if (!o) return i.ringOut;
                                                if (o.ringOut !== i.ringOut) return o.ringOut.enclosingRing() !== i.ringOut ? i.ringOut : i.ringOut.enclosingRing();
                                                i = o.prevInResult(), o = i ? i.prevInResult() : null;
                                            }
                                        }
                                    }
                                ]), e;
                            }(), M = function() {
                                function e(r) {
                                    t(this, e), this.exteriorRing = r, r.poly = this, this.interiorRings = [];
                                }
                                return r(e, [
                                    {
                                        key: "addInterior",
                                        value: function(t) {
                                            this.interiorRings.push(t), t.poly = this;
                                        }
                                    },
                                    {
                                        key: "getGeom",
                                        value: function() {
                                            var t = [
                                                this.exteriorRing.getGeom()
                                            ];
                                            if (null === t[0]) return null;
                                            for(var e = 0, r = this.interiorRings.length; e < r; e++){
                                                var n = this.interiorRings[e].getGeom();
                                                null !== n && t.push(n);
                                            }
                                            return t;
                                        }
                                    }
                                ]), e;
                            }(), G = function() {
                                function e(r) {
                                    t(this, e), this.rings = r, this.polys = this._composePolys(r);
                                }
                                return r(e, [
                                    {
                                        key: "getGeom",
                                        value: function() {
                                            for(var t = [], e = 0, r = this.polys.length; e < r; e++){
                                                var n = this.polys[e].getGeom();
                                                null !== n && t.push(n);
                                            }
                                            return t;
                                        }
                                    },
                                    {
                                        key: "_composePolys",
                                        value: function(t) {
                                            for(var e = [], r = 0, n = t.length; r < n; r++){
                                                var i = t[r];
                                                if (!i.poly) {
                                                    if (i.isExteriorRing()) e.push(new M(i));
                                                    else {
                                                        var o = i.enclosingRing();
                                                        o.poly || e.push(new M(o)), o.poly.addInterior(i);
                                                    }
                                                }
                                            }
                                            return e;
                                        }
                                    }
                                ]), e;
                            }(), T = function() {
                                function e(r) {
                                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : O.compare;
                                    t(this, e), this.queue = r, this.tree = new h(n), this.segments = [];
                                }
                                return r(e, [
                                    {
                                        key: "process",
                                        value: function(t) {
                                            var e = t.segment, r = [];
                                            if (t.consumedBy) return t.isLeft ? this.queue.remove(t.otherSE) : this.tree.remove(e), r;
                                            var n = t.isLeft ? this.tree.insert(e) : this.tree.find(e);
                                            if (!n) throw new Error("Unable to find segment #".concat(e.id, " ") + "[".concat(e.leftSE.point.x, ", ").concat(e.leftSE.point.y, "] -> ") + "[".concat(e.rightSE.point.x, ", ").concat(e.rightSE.point.y, "] ") + "in SweepLine tree. Please submit a bug report.");
                                            for(var i = n, o = n, s = void 0, u = void 0; void 0 === s;)null === (i = this.tree.prev(i)) ? s = null : void 0 === i.key.consumedBy && (s = i.key);
                                            for(; void 0 === u;)null === (o = this.tree.next(o)) ? u = null : void 0 === o.key.consumedBy && (u = o.key);
                                            if (t.isLeft) {
                                                var l = null;
                                                if (s) {
                                                    var h = s.getIntersection(e);
                                                    if (null !== h && (e.isAnEndpoint(h) || (l = h), !s.isAnEndpoint(h))) for(var f = this._splitSafely(s, h), a = 0, p = f.length; a < p; a++)r.push(f[a]);
                                                }
                                                var y = null;
                                                if (u) {
                                                    var g = u.getIntersection(e);
                                                    if (null !== g && (e.isAnEndpoint(g) || (y = g), !u.isAnEndpoint(g))) for(var v = this._splitSafely(u, g), c = 0, x = v.length; c < x; c++)r.push(v[c]);
                                                }
                                                if (null !== l || null !== y) {
                                                    var b = null;
                                                    if (null === l) b = y;
                                                    else if (null === y) b = l;
                                                    else b = P.comparePoints(l, y) <= 0 ? l : y;
                                                    this.queue.remove(e.rightSE), r.push(e.rightSE);
                                                    for(var m = e.split(b), d = 0, E = m.length; d < E; d++)r.push(m[d]);
                                                }
                                                r.length > 0 ? (this.tree.remove(e), r.push(t)) : (this.segments.push(e), e.prev = s);
                                            } else {
                                                if (s && u) {
                                                    var S = s.getIntersection(u);
                                                    if (null !== S) {
                                                        if (!s.isAnEndpoint(S)) for(var _ = this._splitSafely(s, S), k = 0, w = _.length; k < w; k++)r.push(_[k]);
                                                        if (!u.isAnEndpoint(S)) for(var R = this._splitSafely(u, S), I = 0, N = R.length; I < N; I++)r.push(R[I]);
                                                    }
                                                }
                                                this.tree.remove(e);
                                            }
                                            return r;
                                        }
                                    },
                                    {
                                        key: "_splitSafely",
                                        value: function(t, e) {
                                            this.tree.remove(t);
                                            var r = t.rightSE;
                                            this.queue.remove(r);
                                            var n = t.split(e);
                                            return n.push(r), void 0 === t.consumedBy && this.tree.insert(t), n;
                                        }
                                    }
                                ]), e;
                            }(), C = "undefined" != typeof process && process.env.POLYGON_CLIPPING_MAX_QUEUE_SIZE || 1e6, q = "undefined" != typeof process && process.env.POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS || 1e6, F = new (function() {
                                function e() {
                                    t(this, e);
                                }
                                return r(e, [
                                    {
                                        key: "run",
                                        value: function(t, e, r) {
                                            F.type = t, d.reset();
                                            for(var n = [
                                                new z(e, !0)
                                            ], i = 0, o = r.length; i < o; i++)n.push(new z(r[i], !1));
                                            if (F.numMultiPolys = n.length, "difference" === F.type) for(var s = n[0], u = 1; u < n.length;)null !== g(n[u].bbox, s.bbox) ? u++ : n.splice(u, 1);
                                            if ("intersection" === F.type) {
                                                for(var l = 0, f = n.length; l < f; l++)for(var a = n[l], p = l + 1, y = n.length; p < y; p++)if (null === g(a.bbox, n[p].bbox)) return [];
                                            }
                                            for(var v = new h(P.compare), c = 0, x = n.length; c < x; c++)for(var b = n[c].getSweepEvents(), m = 0, E = b.length; m < E; m++)if (v.insert(b[m]), v.size > C) throw new Error("Infinite loop when putting segment endpoints in a priority queue (queue size too big). Please file a bug report.");
                                            for(var S = new T(v), _ = v.size, k = v.pop(); k;){
                                                var w = k.key;
                                                if (v.size === _) {
                                                    var R = w.segment;
                                                    throw new Error("Unable to pop() ".concat(w.isLeft ? "left" : "right", " SweepEvent ") + "[".concat(w.point.x, ", ").concat(w.point.y, "] from segment #").concat(R.id, " ") + "[".concat(R.leftSE.point.x, ", ").concat(R.leftSE.point.y, "] -> ") + "[".concat(R.rightSE.point.x, ", ").concat(R.rightSE.point.y, "] from queue. ") + "Please file a bug report.");
                                                }
                                                if (v.size > C) throw new Error("Infinite loop when passing sweep line over endpoints (queue size too big). Please file a bug report.");
                                                if (S.segments.length > q) throw new Error("Infinite loop when passing sweep line over endpoints (too many sweep line segments). Please file a bug report.");
                                                for(var I = S.process(w), N = 0, O = I.length; N < O; N++){
                                                    var A = I[N];
                                                    void 0 === A.consumedBy && v.insert(A);
                                                }
                                                _ = v.size, k = v.pop();
                                            }
                                            d.reset();
                                            var L = B.factory(S.segments);
                                            return new G(L).getGeom();
                                        }
                                    }
                                ]), e;
                            }());
                            return {
                                union: function(t) {
                                    for(var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)r[n - 1] = arguments[n];
                                    return F.run("union", t, r);
                                },
                                intersection: function(t) {
                                    for(var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)r[n - 1] = arguments[n];
                                    return F.run("intersection", t, r);
                                },
                                xor: function(t) {
                                    for(var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)r[n - 1] = arguments[n];
                                    return F.run("xor", t, r);
                                },
                                difference: function(t) {
                                    for(var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)r[n - 1] = arguments[n];
                                    return F.run("difference", t, r);
                                }
                            };
                        });
                    }).call(this);
                }).call(this, require1("_process"));
            },
            {
                _process: 1
            }
        ]
    }, {}, [
        2
    ])(2);
});


let $3b900d32d339d8a7$var$font;
var $e6193d531cbe28f4$exports = {};
$e6193d531cbe28f4$exports = new URL("../RobotoMono-Medium.5a7b3c17.ttf", import.meta.url).toString();


const $3b900d32d339d8a7$var$fontUrl = new URL($e6193d531cbe28f4$exports);
function $3b900d32d339d8a7$export$513ccb98c53b8039() {
    $3b900d32d339d8a7$var$font = loadFont($3b900d32d339d8a7$var$fontUrl.href);
}
function $3b900d32d339d8a7$export$de27182ff8187d6c() {
    (0, $lyoVb.setupCommon)();
    textFont($3b900d32d339d8a7$var$font);
    noSmooth();
}
function $3b900d32d339d8a7$var$makeRect(cx, cy, s, t) {
    const s2 = s / 2;
    const points = [
        ...Array(4).keys()
    ].map((i)=>{
        const theta = i / 4 * (2 * Math.PI) + t;
        const x = cx + s2 * Math.cos(theta);
        const y = cy + s2 * Math.sin(theta);
        return [
            x,
            y
        ];
    });
    points.push(points[0]);
    return points;
}
function $3b900d32d339d8a7$var$makeChaikin() {
    // https://github.com/georgedoescode/chaikin
    //
    // linear interpolation, return a point(t) between start and end
    function _lerp(start, end, t) {
        return start * (1 - t) + end * t;
    }
    // returned 2 points "sliced" between original 2 points
    function _chaikinCut(a, b, ratio) {
        return [
            {
                x: _lerp(a.x, b.x, ratio),
                y: _lerp(a.y, b.y, ratio)
            },
            {
                x: _lerp(b.x, a.x, ratio),
                y: _lerp(b.y, a.y, ratio)
            }
        ];
    }
    return function(shape, ratio, iterations, close) {
        // no more iterations left, return the result
        if (iterations === 0) return shape;
        // next shape iteration
        const next = [];
        // corner = each vertex ({x, y}) in shape
        const corners = Object.keys(shape);
        const numCorners = close ? corners.length : corners.length - 1;
        for(let i = 0; i < numCorners; i++){
            // side + adjacent side
            const a = shape[corners[i]];
            const b = shape[corners[(i + 1) % corners.length]];
            // "cut" points between each side
            const n = _chaikinCut(a, b, ratio);
            if (!close && i === 0) {
                // ignore the "cut" A vertex for start point of open shapes
                next.push({
                    x: a.x,
                    y: a.y
                });
                next.push({
                    x: n[1].x,
                    y: n[1].y
                });
            } else if (!close && i === numCorners - 1) {
                // ignore the "cut" B vertex for end point of open shapes
                next.push({
                    x: n[0].x,
                    y: n[0].y
                });
                next.push({
                    x: b.x,
                    y: b.y
                });
            } else {
                // add both cut vertices
                next.push({
                    x: n[0].x,
                    y: n[0].y
                });
                next.push({
                    x: n[1].x,
                    y: n[1].y
                });
            }
        }
        return $3b900d32d339d8a7$var$chaikin(next, ratio, iterations - 1, close);
    };
}
const $3b900d32d339d8a7$var$chaikin = $3b900d32d339d8a7$var$makeChaikin();
function $3b900d32d339d8a7$var$drawPoly(poly, isClosed) {
    beginShape();
    let points = !!isClosed ? poly : poly.slice(0, -1);
    points.forEach(([x, y])=>{
        return vertex((0, $lyoVb.w)(x), (0, $lyoVb.h)(y));
    });
    endShape(CLOSE);
}
function $3b900d32d339d8a7$var$makeText(s, x, y, t) {
    const textSizeR = 0.015;
    const chars = Math.floor(1.0 / textSizeR);
    const offset = Math.floor(t * 100);
    textAlign(LEFT);
    textSize((0, $lyoVb.w)(textSizeR));
    fill(0, 0, 10, 0.5);
    noStroke();
    for(let i = 0; i < s.length; i += chars){
        const n = noise(t, i * 0.001);
        const start = i + offset;
        const lengthCap = 15 + Math.floor(n * 20);
        const end = start + chars * 0.5 + lengthCap;
        const line = s.slice(start, end);
        if (n > 0.5) text(line, (0, $lyoVb.w)(-0.45 + Math.floor(n * 30) / 30), (0, $lyoVb.h)(-0.23 + 0.025 * (i / chars) + 0.025 * Math.floor(1 * Math.sin(3 * t * PI))));
    }
}
function $3b900d32d339d8a7$export$e529deb2bfd496dc() {
    (0, $lyoVb.drawCommon)();
    blendMode(BLEND);
    background(10);
    const t = TAU * (0, $lyoVb.frameN);
    const is = 0.2 + 0.05 * Math.sin(t);
    const a1 = [
        $3b900d32d339d8a7$var$makeRect(0.3, 0.3, 0.5, t),
        $3b900d32d339d8a7$var$makeRect(0.3, 0.3, is, t)
    ];
    const a2 = [
        $3b900d32d339d8a7$var$makeRect(0.7, 0.7, 0.5, t * -2),
        $3b900d32d339d8a7$var$makeRect(0.7, 0.7, is * 1.5, -t)
    ];
    const a3 = [
        $3b900d32d339d8a7$var$makeRect(0.3, 0.7, 0.5, t * 1),
        $3b900d32d339d8a7$var$makeRect(0.3, 0.7, is, -t)
    ];
    const a4 = [
        $3b900d32d339d8a7$var$makeRect(0.7, 0.3, 0.5, t * 2),
        $3b900d32d339d8a7$var$makeRect(0.7, 0.3, 0.2, t)
    ];
    const a5 = [
        $3b900d32d339d8a7$var$makeRect(0.1, 0.1, 0.4, -0.5 * t)
    ];
    const a6 = [
        $3b900d32d339d8a7$var$makeRect(0.85, 0.85, 0.4, -1.75 * t)
    ];
    const a7 = [
        $3b900d32d339d8a7$var$makeRect(0.05, 0.95, 0.4, 1.25 * t)
    ];
    const a8 = [
        $3b900d32d339d8a7$var$makeRect(0.55, 0.95, 0.4, 1.5 * t)
    ];
    const b = [
        $3b900d32d339d8a7$var$makeRect(0.5, 0.5, 0.7 + 0.2 * Math.sin(t), QUARTER_PI),
        $3b900d32d339d8a7$var$makeRect(0.5, 0.5, 0.3, QUARTER_PI)
    ];
    const clip = $90ed7a381e6de542$exports.xor(b, a1, a2, a3, a4, a5, a6, a7, a8);
    translate((0, $lyoVb.w)(0.05), (0, $lyoVb.h)(-0.05));
    stroke(150, 100, 100, 1);
    fill(0, 0, 95, 1);
    clip.forEach((poly)=>{
        poly.forEach((poly)=>{
            let points = poly.map(([x, y])=>({
                    x: x,
                    y: y
                }));
            points = $3b900d32d339d8a7$var$chaikin(points, 0.25, 2, false);
            points = points.map(({ x: x, y: y })=>[
                    x,
                    y
                ]);
            $3b900d32d339d8a7$var$drawPoly(points);
        });
    });
    noFill();
    stroke(0, 100, 100);
    clip.forEach((poly)=>poly.forEach($3b900d32d339d8a7$var$drawPoly));
    resetMatrix();
    $3b900d32d339d8a7$var$makeText(JSON.stringify(clip), (0, $lyoVb.w)(0.5), (0, $lyoVb.h)(0.5), (0, $lyoVb.frameN));
    fill(0, 0, 100);
    stroke(0);
    rect((0, $lyoVb.w)(0.775), (0, $lyoVb.h)(0.025), (0, $lyoVb.w)(0.2), (0, $lyoVb.h)(0.14));
    noStroke();
    fill(0);
    textSize((0, $lyoVb.w)(0.02));
    text(` Frame:  ${(0, $lyoVb.frame)}`, (0, $lyoVb.w)(0.775), (0, $lyoVb.h)(0.05));
    text(` FrameN: ${(0, $lyoVb.frameN).toFixed(3)}`, (0, $lyoVb.w)(0.775), (0, $lyoVb.h)(0.075));
    text(` FPS:    ${frameRate().toFixed(3)}`, (0, $lyoVb.w)(0.775), (0, $lyoVb.h)(0.1));
    text(` Time:   ${deltaTime.toFixed(0)} ms`, (0, $lyoVb.w)(0.775), (0, $lyoVb.h)(0.125));
    text(` smooth: false`, (0, $lyoVb.w)(0.775), (0, $lyoVb.h)(0.15));
}



var $gPx2I = parcelRequire("gPx2I");
parcelRequire("d3dEA");
const $c8ad1bf8ca7c2a20$var$source = 'import {\n  easeInOutSine,\n  smoothstep,\n  clamp,\n  w, h,\n  frame,\n  frameN,\n  setFrameN,\n  getCanvasSize,\n  setupCommon,\n  drawCommon,\n  make,\n} from \'../js/common.js\';\nconst polygonClipping = require(\'./polygon-clipping.umd.min.js\');\n\nlet font;\nconst fontUrl = new URL(\'./RobotoMono-Medium.ttf\', import.meta.url);\nexport function preload() {\n	font = loadFont(fontUrl.href);\n}\n\nexport function setup() {\n	setupCommon();\n\n	textFont(font);\n\n	noSmooth();\n}\n\nfunction makeRect(cx, cy, s, t) {\n	const s2 = s / 2;\n	const points = [...Array(4).keys()].map(i => {\n		const theta = (i / 4) * (2 * Math.PI) + t;\n		const x = cx + s2 * Math.cos(theta);\n		const y = cy + s2 * Math.sin(theta);\n		return [x, y];\n	});\n	points.push(points[0]);\n	return points;\n}\n\nfunction makeChaikin() {\n	// https://github.com/georgedoescode/chaikin\n	//\n	// linear interpolation, return a point(t) between start and end\n	function _lerp(start, end, t) {\n		return start * (1 - t) + end * t;\n	}\n\n	// returned 2 points "sliced" between original 2 points\n	function _chaikinCut(a, b, ratio) {\n		return [\n			{ x: _lerp(a.x, b.x, ratio), y: _lerp(a.y, b.y, ratio) },\n			{ x: _lerp(b.x, a.x, ratio), y: _lerp(b.y, a.y, ratio) }\n		];\n	}\n\n	return function(shape, ratio, iterations, close) {\n		// no more iterations left, return the result\n		if (iterations === 0) return shape;\n\n		// next shape iteration\n		const next = [];\n		// corner = each vertex ({x, y}) in shape\n		const corners = Object.keys(shape);\n		const numCorners = close ? corners.length : corners.length - 1;\n\n		for (let i = 0; i < numCorners; i++) {\n			// side + adjacent side\n			const a = shape[corners[i]];\n			const b = shape[corners[(i + 1) % corners.length]];\n			// "cut" points between each side\n			const n = _chaikinCut(a, b, ratio);\n\n			if (!close && i === 0) {\n				// ignore the "cut" A vertex for start point of open shapes\n				next.push({ x: a.x, y: a.y });\n				next.push({ x: n[1].x, y: n[1].y });\n			} else if (!close && i === numCorners - 1) {\n				// ignore the "cut" B vertex for end point of open shapes\n				next.push({ x: n[0].x, y: n[0].y });\n				next.push({ x: b.x, y: b.y });\n			} else {\n				// add both cut vertices\n				next.push({ x: n[0].x, y: n[0].y });\n				next.push({ x: n[1].x, y: n[1].y });\n			}\n		}\n\n		return chaikin(next, ratio, iterations - 1, close);\n	};\n}\n\nconst chaikin = makeChaikin();\n\nfunction drawPoly(poly, isClosed) {\n	beginShape();\n	let points = !!isClosed ? poly : poly.slice(0, -1);\n	points\n		.forEach(([x, y]) => {\n			return vertex(w(x), h(y))\n		});\n	endShape(CLOSE);\n}\n\nfunction makeText(s, x, y, t) {\n	const textSizeR = 0.015;\n	const chars = Math.floor(1.0 / textSizeR);\n	const offset = Math.floor(t * 100);\n\n	textAlign(LEFT);\n	textSize(w(textSizeR));\n	fill(0, 0, 10, 0.5);\n	noStroke();\n\n	for (let i = 0; i < s.length; i += chars) {\n		const n = noise(t, i * 0.001);\n\n		const start = i + offset;\n		const lengthCap = 15 + Math.floor(n * 20);\n		const end = start + chars * 0.5 + lengthCap;\n		const line = s.slice(start, end)\n\n		if (n > 0.5)\n			text(line,\n				w(0.05 - 0.5 + Math.floor(n * 30) / 30),\n				h(0.02 +\n					(10 * -0.025) +\n					0.025 * (i / chars) +\n					0.025 * Math.floor(1 * Math.sin(3 * t * PI))))\n	}\n}\n\nexport function draw() {\n	drawCommon();\n	blendMode(BLEND);\n	background(10);\n\n	const t = TAU * frameN;\n	const is = 0.2 + 0.05 * Math.sin(t);\n	const a1 = [makeRect(0.3, 0.3, 0.5, t), makeRect(0.3, 0.3, is, t)];\n	const a2 = [makeRect(0.7, 0.7, 0.5, t * -2), makeRect(0.7, 0.7, is * 1.5, -t)];\n	const a3 = [makeRect(0.3, 0.7, 0.5, t * 1), makeRect(0.3, 0.7, is, -t)];\n	const a4 = [makeRect(0.7, 0.3, 0.5, t * 2), makeRect(0.7, 0.3, 0.2, t)];\n	const a5 = [makeRect(0.1, 0.1, 0.4, -0.5 * t)];\n	const a6 = [makeRect(0.85, 0.85, 0.4, -1.75 * t)];\n	const a7 = [makeRect(0.05, 0.95, 0.4, 1.25 * t)];\n	const a8 = [makeRect(0.55, 0.95, 0.4, 1.5 * t)];\n\n	const b = [makeRect(0.5, 0.5, 0.7 + 0.2 * Math.sin(t), QUARTER_PI), makeRect(0.5, 0.5, 0.3, QUARTER_PI)];\n	const clip = polygonClipping.xor(b, a1, a2, a3, a4, a5, a6, a7, a8);\n\n	translate(w(0.05), h(-0.05));\n	stroke(150, 100, 100, 1);\n	fill(0, 0, 95, 1);\n	clip.forEach(poly => {\n		poly.forEach(poly => {\n			let points = poly.map(([x, y]) => ({ x, y }));\n			points = chaikin(points, 0.25, 2, false);\n			points = points.map(({ x, y }) => ([x, y]));\n			drawPoly(points);\n		});\n	});\n	noFill()\n	stroke(0, 100, 100);\n	clip.forEach(poly => poly.forEach(drawPoly));\n	resetMatrix();\n\n	makeText(JSON.stringify(clip), w(0.5), h(0.5), frameN);\n\n	fill(0, 0, 100);\n	stroke(0);\n	rect(w(0.775), h(0.025), w(0.2), h(0.14));\n	noStroke();\n	fill(0);\n	textSize(w(0.02));\n	text(` Frame:  ${frame}`, w(0.775), h(0.05));\n	text(` FrameN: ${frameN.toFixed(3)}`, w(0.775), h(0.075));\n	text(` FPS:    ${frameRate().toFixed(3)}`, w(0.775), h(0.1));\n	text(` Time:   ${deltaTime.toFixed(0)} ms`, w(0.775), h(0.125));\n	text(` smooth: false`, w(0.775), h(0.15));\n}\n';
(0, $gPx2I.make)({
    setup: $3b900d32d339d8a7$export$de27182ff8187d6c,
    draw: $3b900d32d339d8a7$export$e529deb2bfd496dc,
    preload: $3b900d32d339d8a7$export$513ccb98c53b8039
}, $c8ad1bf8ca7c2a20$var$source);


//# sourceMappingURL=05.bc1c6d8f.js.map
